import styled from "styled-components";

export const StyledDecimals = styled.div`
    padding: 12px 0;
    width: 100%;
    justify-content: flex-start;
    font-size: 14px;
    line-height: 21px;
  `;